import { useEffect, useRef, useState, useCallback, useMemo } from 'react';

export default function useLiveBalance(year, intervalMs = 15000) {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const prevBalance = useRef(null);

  const token = localStorage.getItem('jwtToken');

  // 🔑 Extragem club_id din JWT (o singură dată)
  const clubId = useMemo(() => {
    try {
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload?.data?.club_id || payload?.data?.club?.id || null;
    } catch {
      return null;
    }
  }, [token]);

  const fetchBalance = useCallback(async () => {
    if (!clubId || !year) return;

    try {
      const res = await fetch(
        `https://www.fro.ro/api/clubs/club-credit.php?club_id=${clubId}&year=${year}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = await res.json();

      if (data.success) {
        prevBalance.current = balance;
        setBalance(Number(data.credit ?? 0));
      }
    } catch (e) {
      console.error('Live balance error', e);
    } finally {
      setLoading(false);
    }
  }, [clubId, year, token, balance]);

  useEffect(() => {
    fetchBalance();
    const timer = setInterval(fetchBalance, intervalMs);
    return () => clearInterval(timer);
  }, [fetchBalance, intervalMs]);

  return {
    balance,
    loading,
    prevBalance: prevBalance.current,
    refresh: fetchBalance,
  };
}
